export default __webpack_public_path__ + "static/canada-72e3ff6002a2ff82ea7a8139764b7c61.svg";